import React from 'react';
import { Icon } from './Icon.js';
export const IconParkingSign = ({ ...props }) => {
    return (React.createElement(Icon, { size: "24px", ...props },
        React.createElement("path", { d: "M9 16.9999V7L12.5 7C14.433 7 16 8.56699 16 10.5C16 12.433 14.433 13.9999 12.5 13.9999H9.19754", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "square", fill: "none" }),
        React.createElement("path", { d: "M3 3L3 21L21 21L21 3L3 3Z", stroke: "currentColor", strokeWidth: "2", strokeMiterlimit: "10", strokeLinecap: "square", "data-color": "color-2", fill: "none" })));
};
//# sourceMappingURL=IconParkingSign.js.map